export enum ExportableFilePrefix {
  AI = "AI",
  SN = "SN",
}

export enum ExportableFileType {
  PredictiveAI = "predictive_ai",
  StackedNiche = "stacked_niche",
}

export interface ExportableFilesSearchParams {
  account_id: number;
  type: ExportableFileType;
}

export interface ExportableFile {
  file_id: string;
  account_id: number;
  name: string;
  type: ExportableFileType;
}

export interface ExportableFilesResponse {
  total: number;
  results: ExportableFile[];
}
